import {
  MODAL_INTERACTION,
  MODAL_HIDDEN,
  MODAL_DATA_LOADED,
  VALIDATED_EXPRESSION,
} from '../actions/constants';
import ModalAddColumn from '../components/modals/ModalAddColumn';
import { ADD_COLUMN } from '../util/enums/EnumLayers';
import Column from '../util/Column';

const INITIAL_STATE = {
  name: 'my_column', // the name of the column
  expression: '', // the expression
  replaceExisting: false, // null means 'put at end' (for backwards compatibility).

  nameError: null,
  expressionErrorMsg: null,
  expressionValidated: false,

  cursorPosition: 0,

  readyForSave: false,
};

function nameError(columns, name, replaceExisting = false) {
  if (name.length === 0) {
    return null;
  }
  if (replaceExisting) {
    return null;
  }
  if (name[0].toLowerCase() === name[0].toUpperCase()) {
    return 'Column name must start with a letter.';
  }
  if (columns.findIndex((c) => c.name().toString() === name) !== -1) {
    return `Column name "${name}" already in use.`;
  }
  return null;
}

function interaction(state, payload) {
  switch (payload.section) {
    case 'name-changed': {
      const newState = {
        ...state,
        name: payload.newValue.replace(/[^A-Za-z0-9_]+/gi, '_'),
      };
      newState.nameError = nameError(payload.columns, newState.name);
      return newState;
    }
    case 'expression-changed':
      return {
        ...state,
        expression: payload.newValue,
        expressionValidated: false,
      };
    case 'cursor-pos':
      return { ...state, cursorPosition: payload.position };
    case 'column-option':
      return {
        ...state,
        expression:
          state.expression.slice(0, state.cursorPosition) +
          payload.columnName.toString() +
          state.expression.slice(state.cursorPosition, state.expression.length),
        cursorPosition:
          state.cursorPosition + payload.columnName.toString().length,
      };
    case 'toggleReplaceExisting':
      return {
        ...state,
        expressionValidated: false,
        replaceExisting: !state.replaceExisting,
        nameError: nameError(
          payload.columns,
          state.name,
          !state.replaceExisting,
        ),
      };
    default:
      return state;
  }
}

function readyForSave(state) {
  return (
    state.expressionValidated &&
    (state.name.length > 0 || state.replaceExisting) &&
    !state.nameError
  );
}

const modalAddColumn = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_INTERACTION: {
      if (action.payload.modalType !== ADD_COLUMN) {
        return state;
      }
      const newState = interaction(state, action.payload.props);
      newState.readyForSave = readyForSave(newState);
      return newState;
    }
    case VALIDATED_EXPRESSION: {
      if (action.payload.expression !== state.expression) {
        // is for previous expression
        return state;
      }
      const newState = {
        ...state,
        expressionErrorMsg: action.payload.json._errorMessage,
        expressionValidated: !action.payload.json._errorMessage,
      };
      newState.readyForSave = readyForSave(newState);
      return newState;
    }
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case MODAL_DATA_LOADED:
      if (action.payload.modal === ModalAddColumn) {
        const columns = action.payload.json.map((c) => Column.build(c));
        if (action.payload.existingLayer) {
          return {
            ...INITIAL_STATE,
            name: action.payload.existingLayer.name(),
            expression: action.payload.existingLayer.expression(),
            replaceExisting: action.payload.existingLayer.replaceExisting(),
            nameError: nameError(columns, action.payload.existingLayer.name()),
            cursorPosition: action.payload.existingLayer.expression().length,
          };
        }
        if (
          action.payload.additionalOptions &&
          action.payload.additionalOptions.expression
        ) {
          return {
            ...INITIAL_STATE,
            name: action.payload.additionalOptions.name,
            expression: action.payload.additionalOptions.expression,
            nameError: nameError(
              columns,
              action.payload.additionalOptions.name,
            ),
            cursorPosition: action.payload.additionalOptions.expression.length,
          };
        }
        // loaded modal fresh (but still check that default name isn't already in use)
        return {
          ...INITIAL_STATE,
          nameError: nameError(columns, INITIAL_STATE.name),
        };
      }
      return state;
    default:
      return state;
  }
};

export default modalAddColumn;
